import { BitmapLayer, GeoJsonLayer } from '@deck.gl/layers';
import DeckGL from 'deck.gl';
import { useEffect, useState } from 'react';
import { Map } from 'react-map-gl';
import Box from '@mui/material/Box';
function RasterLayer() {
  const [bounds, setBounds] = useState(null);
  

  useEffect(() => {
    fetch('/data/rasters/raster_bounds_georgetown.json')
      .then(res => res.json())
      .then(setBounds)
      .then(() => console.log(bounds));
  }, []);

  if (!bounds) return null;

  const rasterLayer = new BitmapLayer({
    id: 'raster-layer',
    image: '/data/rasters/raster_normalized_georgetown.png',
    bounds: bounds, 
    opacity: 1
  });

  const geoJsonLayer = new GeoJsonLayer({
    id: 'geojson-layer',
    data: '/data/geojson/binary_pixels.geojson',
    stroked: false,
    filled: true,
    getFillColor: [50, 50, 50, 120], // dark transparent gray (RGBA)
    lineWidthMinPixels: 1,
  });

  const layers = [geoJsonLayer, rasterLayer];

  return layers;
}

const BLUE = [0, 112, 255, 180]; // Absorbed carbon (net negative)
const RED = [255, 0, 0, 180];    // Emitted carbon (net positive)

function CarbonBalanceLegend() {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 20,
        right: 20,
        background: 'rgba(255,255,255,0.95)',
        borderRadius: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        p: '12px 16px',
        zIndex: 2,
        minWidth: 260,
        color: '#222',
        fontSize: 14,
        maxWidth: 340,
      }}
    >
      <Box sx={{ fontWeight: 600, mb: 1, fontSize: 12, color: "#000" }}>
        Balance de carbono acumulado (2000-2022)
      </Box>
     
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.75 }}>
        <Box
          sx={{
            display: 'inline-block',
            width: 18,
            height: 18,
            borderRadius: 1,
            background: `rgba(${BLUE.join(',')})`,
            mr: 1,
            border: '1px solid #ccc'
          }}
        />
        <Box sx={{ fontSize: 13, color: "#000" }}>Negative carbon balance (absorption)</Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box
          sx={{
            display: 'inline-block',
            width: 18,
            height: 18,
            borderRadius: 1,
            background: `rgba(${RED.join(',')})`,
            mr: 1,
            border: '1px solid #ccc'
          }}
        />
        <Box sx={{ fontSize: 13, color: "#000" }}>Positive carbon balance (emission)</Box>
      </Box>
    </Box>
  );
}

export default function CarbonBalance() {
  const makeRasterStyle = (urlTemplate, attribution = "") => ({
    version: 8,
    sources: {
      rastertiles: {
        type: "raster",
        tiles: [urlTemplate],
        tileSize: 256,
        attribution,
      },
    },
    layers: [
      {
        id: "rastertiles",
        type: "raster",
        source: "rastertiles",
      },
    ],
  });
  const [styleKey, setStyleKey] = useState("Streets");
  const BASEMAPS = {
    "Satellite": "https://raw.githubusercontent.com/go2garret/maps/main/src/assets/json/arcgis_hybrid.json",
    "Light Mode": makeRasterStyle(
      "https://basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png",
      '© OpenStreetMap contributors © CARTO'
    ),
    "Dark Mode": makeRasterStyle(
      "https://basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}.png",
      '© OpenStreetMap contributors © CARTO'
    ),
     "Streets": makeRasterStyle(
      "https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png",
      '© OpenStreetMap contributors © CARTO'
    ),
    "Open Street Map": makeRasterStyle(
      "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
      '© OpenStreetMap contributors'
    )
  };
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div className="absolute left-3 top-3 z-10 text-black">
            <select
              value={styleKey}
              onChange={(e) => setStyleKey(e.target.value)}
              className="bg-white/90 backdrop-blur px-3 py-1.5 rounded-md text-sm shadow border border-black/10"
            >
              {Object.keys(BASEMAPS).map((k) => (
                <option key={k} value={k}>
                  {k}
                </option>
              ))}
            </select>
          </div>
       <DeckGL
        initialViewState={{
            latitude: 6.763,
            longitude: -58.055,
            zoom: 10,
            pitch: 0,
            bearing: 0,
        }}
        controller={true}
        layers={RasterLayer()}
      >
       <Map
          mapStyle={BASEMAPS[styleKey]}
          className="w-full"
          attributionControl={false}
        />
        <CarbonBalanceLegend />
      </DeckGL>
    </div>
  );
}

